/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/MemberAnnouncements',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function markAsRead(id) {
        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/account/announcement/',
            data: JSON.stringify({ 'announcementId': id }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('MemberAnnouncements -> markAsRead');
                Roc.Logger.info(xhr);
            }
        });
    }

    function bindEvents() {
        $(document).on('click', '.member-announcement button.roc-close', function () {
            var id = $(this).closest('.member-announcement').attr('data-id');
            markAsRead(id);
        });
    }

    function init() {
        bindEvents();
    };

    // public methods
    var MemberAnnouncements = {
        init: init
    };

    Roc.Logger.debug('MemberAnnouncements.js Loaded:', MemberAnnouncements);

    // return public methods
    return MemberAnnouncements;
});
